import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { edit_icon, no_image } from '../../assets/imgs';
import CancelIcon from '@mui/icons-material/Cancel';
import { Table } from '../../components/Table/Table';
import { Cropper } from 'react-cropper';
import { useDefaultBannerEditMutation,  useLazyDefaultBannerListQuery, useLazyDefaultBannerViewQuery } from '../redux/api/api';
import { toast } from 'react-toastify';

const DefaultBanner = () => {
    const [popup, setPopup] = useState(false);
    const [list, setList] = useState([]);
    const [image, setImage] = useState(null); // State for the selected image
    const [croppedImage, setCroppedImage] = useState(no_image); // State for the cropped image
    const cropperRef = useRef(null); // Ref for the Cropper component
    const fileInputRef = useRef(null); // Ref for the file input
    const [pageno, setPageno] = useState(1);
    const [pagecount, setPagecount] = useState("");
    const [height, setHeight] = useState(false)
    const [loader, setLoader] = useState(false);
    const [url, setUrl] = useState();

     const rolePermissions = JSON.parse(localStorage.getItem('permissions'))


    const [defaultBannerApi] = useLazyDefaultBannerListQuery();
    const [defaultEditApi] = useDefaultBannerEditMutation();
    const [defaultViewApi] = useLazyDefaultBannerViewQuery();


    // Handle file selection
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setImage(reader.result); // Set the selected image for cropping
            };
            reader.readAsDataURL(file);
        }
    };

    // Handle image cropping
    const handleCrop = () => {
        if (cropperRef.current) {
            const cropper = cropperRef.current.cropper;
            const croppedImageUrl = cropper.getCroppedCanvas().toDataURL(); // Get cropped image as data URL
            fetch(croppedImageUrl)
                .then((res) => res.blob())
                .then((blob) => {
                    const file = new File([blob], "File name", { type: "image/png" });
                    setCroppedImage(file); // Set the cropped image
                });
            setImage(null); // Close the cropper after cropping
            setHeight(false);
        }
    };





    const defaultBannerList = () => {
        defaultBannerApi()
            .unwrap()
            .then((res) => {
                console.log("res", res);
                setList(res?.data);
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    const defaultBannerView = () => {
        defaultViewApi()
            .unwrap()
            .then((res) => {
                console.log("res", res);
                setCroppedImage(res?.data?.[0]?.setting_value?.image);
                setUrl(res?.data?.[0]?.setting_value?.redirect_url);
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    const defaultBannerEdit = () => {
        const formdata = new FormData();
        if (croppedImage?.name) {
            formdata.append("home_banner", croppedImage)
        }
        formdata.append("redirect_url", url)
        setLoader(true);
        defaultEditApi(formdata)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.status == "success") {
                    setLoader(false);
                    toast.success(res?.message);
                    setPopup(false);
                    defaultBannerList();
                }
            })
            .catch((err) => {
                console.log("err", err);
            }).finally(() => {
                setLoader(false);
            })
    }

    useEffect(() => {
        defaultBannerList();
    }, []);


    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{row.index + 1}</p>;
                },
            },
            {
                Header: "Image",
                accessor: "setting_value",
                Cell: ({ value, row }) => {
                    return (
                        <img src={value?.image} style={{ height: "50px", width: "70px", borderRadius: "5px" }} />
                    )
                },
            },
            {
                Header: "Action",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">
                                {rolePermissions?.includes('CAN-EDIT-MASTER') &&
                                <button
                                    onClick={() => { setPopup(true); defaultBannerView() }}
                                    className="cust-btn "
                                >
                                    <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                                </button>}
                            </div>
                        </React.Fragment>
                    );
                },
            },
        ],
        []
    );


    return (
        <div className="dashRightView home_section" >
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
                    Masters - Default Banner
                </h2>
            </div>
            <div>
                <Table columns={columns} data={list || []} setPageno={setPageno} pagecount={pagecount} show={false} />
            </div>

            {popup && (
                <div className="img-popup-design">
                    <div className="img-popup">
                        <div className='d-flex ac-jb'
                            onClick={() => { setPopup(false); }}
                        >
                            <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
                                Edit
                            </h2>
                            <CancelIcon />
                        </div>

                        <div className='d-flex ac-jb mt-3'>
                            <div className='w-50'>
                                <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                    Image (4853x3235 px)
                                </h4>
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                    ref={fileInputRef} // Use the ref here
                                />
                                <button
                                    className="upload-btn f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 mb-3"
                                    onClick={() => { fileInputRef.current.click(); setHeight(true) }}
                                >
                                    Select Image
                                </button>
                            </div>
                            <div className='w-50'>
                                {image && (
                                    <div>
                                        <Cropper
                                            ref={cropperRef}
                                            src={image}
                                            aspectRatio={1.5} // Square aspect ratio
                                            guides={false}
                                            viewMode={1}
                                            autoCropArea={1}
                                            background={false}
                                            responsive={true}
                                            style={{ height: 300, width: '100%' }} // Ensure the cropper has a defined size
                                        />
                                        <button
                                            className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                                            onClick={handleCrop}
                                        >
                                            Crop Image
                                        </button>
                                    </div>
                                )}
                                {console.log(croppedImage, "crpp")}

                                <img onChange={(e) => setCroppedImage(e.target.value)}
                                    src={croppedImage ? croppedImage?.name ? URL.createObjectURL(croppedImage) : croppedImage : no_image}
                                    style={{
                                        width: '150px',
                                        height: '100px',
                                        margin: '10px 0px',
                                    }}
                                    alt="Cropped"
                                />
                            </div>
                        </div>

                        <input type="text" value={url} onChange={(e) => setUrl(e.target.value)} className="input-pop mt-2 w-100" placeholder="URL" />

                        <div style={{ textAlign: 'center', marginTop: '30px' }}>
                            <button
                                onClick={() => { defaultBannerEdit() }}
                                className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
                                {loader && (
                                    <div
                                        class="spinner-border spinner-border-sm "
                                        role="status"
                                        style={{ marginRight: "5px" }}
                                    ></div>
                                )} Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
export default DefaultBanner